import DocumentsTemplateEdit from 'routes/operator/document-templates/edit';
import DocumentsTemplateCreate from 'routes/operator/document-templates/create';
import DocumentsTemplates from 'routes/operator/document-templates/list';
import DocumentsManageTokens from 'routes/operator/document-templates/manage-tokens';

import DocumentsPackageEdit from 'routes/operator/document-packages/edit';
import DocumentsPackageCreate from 'routes/operator/document-packages/create';
import DocumentsPackages from 'routes/operator/document-packages/list';

import UserEdit from 'routes/operator/users/edit';
import UserCreate from 'routes/operator/users/create';
import Users from 'routes/operator/users/list';

import ClientEdit from 'routes/operator/clients/edit';
import ClientCreate from 'routes/operator/clients/create';
import Clients from 'routes/operator/clients/list';

import FieldEdit from 'routes/operator/fields/edit';
import FieldCreate from 'routes/operator/fields/create';
import Fields from 'routes/operator/fields/list';

import SegmentEdit from 'routes/operator/segments/edit';
import SegmentCreate from 'routes/operator/segments/create';
import Segments from 'routes/operator/segments/list';
import SegmentElementEdit from 'routes/operator/segments/elements/edit';
import SegmentElementManageTokens from 'routes/operator/segments/elements/manage-tokens';
import SegmentElementCreate from 'routes/operator/segments/elements/create';

import ClientsReport from 'routes/operator/reports';
import ClientsReportUsage from 'routes/operator/reports/usage';

import ClientReports from 'routes/client/reports/documents';
import ClientDocumentsByAction from 'routes/client/reports/documents-by-action';
import ClientLeavesReports from 'routes/client/reports/leaves';
import LeavesReportsSummary from 'routes/client/reports/leaves-summary';
import LeavesReportsList from 'routes/client/reports/leaves-list';
import LeavesAvailability from 'routes/client/reports/leaves-availability';
import EmployeeData from 'routes/client/reports/employee-data';
import ClientMunicipalityReports from 'routes/client/reports/municipality';
import LeavesReportsFormSixtySeven from 'routes/client/reports/leaves-form-sixty-seven';
import ClientHourlyAbsencesReports from 'routes/client/reports/hourly-absences';
import ClientHealthAndSafetyTrainingReports from 'routes/client/reports/health-and-safety-training';
import ClientWorkTripsReports from 'routes/client/reports/work-trips';
import ClientLeaves from 'routes/client/leaves/list';
import ClientLeavesCalendar from 'routes/client/leaves/calendar';
import ClientLeavesStatistics from 'routes/client/leaves/statistics';
import ClientLeavesCompleted from 'routes/client/leaves/list-completed';
import ClientHome from 'routes/client/home';
import ClientHourlyAbsences from 'routes/client/hourly-absences/list';
import HealthAndSafetyTraining from 'routes/client/health-and-safety-training/list';
import HealthAndSafetyTrainingCompleted from 'routes/client/health-and-safety-training/list-completed';
import WorkTrips from 'routes/client/work-trips/list';
import WorkTripsCompleted from 'routes/client/work-trips/list-completed';
import WorkTripsCalendar from 'routes/client/work-trips/calendar';

import ClientArchives from 'routes/client/archives';
import ClientArchiveDownload from 'routes/client/archives/archives';

import ClientDocumentsWizardStep1 from 'routes/client/documents-wizard/step-1';
import ClientDocumentsWizardStep2 from 'routes/client/documents-wizard/step-2';
import ClientDocumentsWizardStep3 from 'routes/client/documents-wizard/step-3';
import ClientDocumentsWizardStep4 from 'routes/client/documents-wizard/step-4';
import ClientDocumentsWizardStep5 from 'routes/client/documents-wizard/step-5';

import ClientDocumentsTemplateEdit from 'routes/client/document-templates/edit';
import ClientDocumentsTemplateCreate from 'routes/client/document-templates/create';
import ClientDocumentsTemplates from 'routes/client/document-templates/list';
import ClientDocumentsManageTokens from 'routes/client/document-templates/manage-tokens';

import ClientFieldEdit from 'routes/client/fields/edit';
import ClientFieldCreate from 'routes/client/fields/create';
import ClientFields from 'routes/client/fields/list';

import ClientSegmentEdit from 'routes/client/segments/edit';
import ClientSegmentCreate from 'routes/client/segments/create';
import ClientSegments from 'routes/client/segments/list';
import ClientSegmentElementEdit from 'routes/client/segments/elements/edit';
import ClientSegmentElementManageTokens from 'routes/client/segments/elements/manage-tokens';
import ClientSegmentElementCreate from 'routes/client/segments/elements/create';

import ClientDocumentsReceived from 'routes/client/documents/received';
import ClientDocumentsForSignSend from 'routes/client/documents/ready-for-sign-send';
import ClientDocumentsSent from 'routes/client/documents/sent';
import ClientDocumentsArchived from 'routes/client/documents/archived';
import ClientDocumentsTrash from 'routes/client/documents/trash';

import ClientDocumentActivity from 'routes/client/document-activity';
import ClientMultipleDocumentActivity from 'routes/client/multiple-document-activity';

import ClientStructureGroups from 'routes/client/structure/groups/list';
import ClientStructureGroupsCreate from 'routes/client/structure/groups/create';
import ClientStructureGroupsEdit from 'routes/client/structure/groups/edit';

import ClientStructureRoles from 'routes/client/structure/roles/list';
import ClientStructureRolesCreate from 'routes/client/structure/roles/create';
import ClientStructureRolesEdit from 'routes/client/structure/roles/edit';

import ClientStructureEmployees from 'routes/client/structure/employees/list';
import ClientStructureEmployeesCreate from 'routes/client/structure/employees/create';
import ClientStructureEmployeesImport from 'routes/client/structure/employees/import';
import ClientStructureEmployeesEdit from 'routes/client/structure/employees/edit';

import ClientStructureScenarios from 'routes/client/structure/scenarios';
import ClientStructureOvertimes from 'routes/client/structure/overtime';

import ClientStructureMultiActions from 'routes/client/structure/multi-actions';

import HomeScreen from 'routes/operator/home';
import { IRouteConfig } from './common-routes';

const routes: IRouteConfig[] = [
  {
    path: '/home',
    component: HomeScreen,
  },
  {
    path: '/document-templates/edit/:id',
    component: DocumentsTemplateEdit,
  },
  {
    path: '/document-templates/manage-tokens/:id',
    component: DocumentsManageTokens,
  },
  {
    path: '/document-templates/create',
    component: DocumentsTemplateCreate,
  },
  {
    path: '/document-templates',
    component: DocumentsTemplates,
  },
  {
    path: '/documents-packages/edit/:id',
    component: DocumentsPackageEdit,
  },
  {
    path: '/documents-packages/create',
    component: DocumentsPackageCreate,
  },
  {
    path: '/documents-packages',
    component: DocumentsPackages,
  },
  {
    path: '/users/edit/:id',
    component: UserEdit,
  },
  {
    path: '/users/create',
    component: UserCreate,
  },
  {
    path: '/users',
    component: Users,
  },
  {
    path: '/clients/edit/:id',
    component: ClientEdit,
  },
  {
    path: '/clients/create',
    component: ClientCreate,
  },
  {
    path: '/clients',
    component: Clients,
  },
  {
    path: '/fields/edit/:id',
    component: FieldEdit,
  },
  {
    path: '/fields/create',
    component: FieldCreate,
  },
  {
    path: '/fields',
    component: Fields,
  },
  {
    path: '/reports/usage',
    component: ClientsReportUsage,
  },
  {
    path: '/reports',
    component: ClientsReport,
  },
  {
    path: '/segments/:segmentId/elements/edit/:id',
    component: SegmentElementEdit,
  },
  {
    path: '/segments/:segmentId/elements/manage-tokens/:id',
    component: SegmentElementManageTokens,
  },
  {
    path: '/segments/:segmentId/elements/create',
    component: SegmentElementCreate,
  },
  {
    path: '/segments/edit/:id',
    component: SegmentEdit,
  },
  {
    path: '/segments/create',
    component: SegmentCreate,
  },
  {
    path: '/segments',
    component: Segments,
  },
  {
    path: '/client/:clientId/document-templates/edit/:id',
    component: ClientDocumentsTemplateEdit,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/document-templates/manage-tokens/:id',
    component: ClientDocumentsManageTokens,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/document-templates/create',
    component: ClientDocumentsTemplateCreate,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/document-templates',
    component: ClientDocumentsTemplates,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/fields/edit/:id',
    component: ClientFieldEdit,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/fields/create',
    component: ClientFieldCreate,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/fields',
    component: ClientFields,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/segments/:segmentId/elements/edit/:id',
    component: ClientSegmentElementEdit,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/segments/:segmentId/elements/manage-tokens/:id',
    component: ClientSegmentElementManageTokens,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/segments/:segmentId/elements/create',
    component: ClientSegmentElementCreate,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/segments/edit/:id',
    component: ClientSegmentEdit,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/segments/create',
    component: ClientSegmentCreate,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/segments',
    component: ClientSegments,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/documents/received',
    component: ClientDocumentsReceived,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/documents/sent',
    component: ClientDocumentsSent,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/documents/archived',
    component: ClientDocumentsArchived,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/documents/trash',
    component: ClientDocumentsTrash,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/archives/:id',
    component: ClientArchiveDownload,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/archives',
    component: ClientArchives,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/document-activity/:id',
    component: ClientDocumentActivity,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/multiple-document-activity/:id',
    component: ClientMultipleDocumentActivity,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/documents/ready-for-sign-and-send',
    component: ClientDocumentsForSignSend,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/structure/groups/edit/:id',
    component: ClientStructureGroupsEdit,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/structure/groups/create',
    component: ClientStructureGroupsCreate,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/structure/groups',
    component: ClientStructureGroups,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/structure/roles/edit/:id',
    component: ClientStructureRolesEdit,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/structure/roles/create',
    component: ClientStructureRolesCreate,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/structure/roles',
    component: ClientStructureRoles,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/structure/employees/edit/:id',
    component: ClientStructureEmployeesEdit,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/structure/employees/create',
    component: ClientStructureEmployeesCreate,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/structure/employees/import',
    component: ClientStructureEmployeesImport,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/structure/employees',
    component: ClientStructureEmployees,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/structure/scenarios',
    component: ClientStructureScenarios,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/structure/overtimes',
    component: ClientStructureOvertimes,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/structure/multi-actions/:id',
    component: ClientStructureMultiActions,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/structure/multi-actions',
    component: ClientStructureMultiActions,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/documents-wizard/step-1',
    component: ClientDocumentsWizardStep1,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/documents-wizard/step-2',
    component: ClientDocumentsWizardStep2,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/documents-wizard/step-3',
    component: ClientDocumentsWizardStep3,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/documents-wizard/step-4',
    component: ClientDocumentsWizardStep4,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/documents-wizard/step-5',
    component: ClientDocumentsWizardStep5,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/reports/leaves',
    component: ClientLeavesReports,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/reports/leaves-summary',
    component: LeavesReportsSummary,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/reports/leaves-list',
    component: LeavesReportsList,
  },
  {
    path: '/client/:clientId/reports/leaves-availability',
    component: LeavesAvailability,
  },
  {
    path: '/client/:clientId/reports/employee-data',
    component: EmployeeData,
  },
  {
    path: '/client/:clientId/reports/documents',
    component: ClientReports,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/reports/documents-by-action',
    component: ClientDocumentsByAction,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/reports/municipality',
    component: ClientMunicipalityReports,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/reports/leaves-form-76',
    component: LeavesReportsFormSixtySeven,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/reports/hourly-absences',
    component: ClientHourlyAbsencesReports,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/reports/health-and-safety-training',
    component: ClientHealthAndSafetyTrainingReports,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/reports/work-trips',
    component: ClientWorkTripsReports,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/leaves/calendar',
    component: ClientLeavesCalendar,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/leaves/statistics',
    component: ClientLeavesStatistics,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/leaves/completed',
    component: ClientLeavesCompleted,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/leaves',
    component: ClientLeaves,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/hourly-absences',
    component: ClientHourlyAbsences,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/health-and-safety-training/completed',
    component: HealthAndSafetyTrainingCompleted,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/health-and-safety-training',
    component: HealthAndSafetyTraining,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/work-trips/completed',
    component: WorkTripsCompleted,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/work-trips/calendar',
    component: WorkTripsCalendar,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId/work-trips',
    component: WorkTrips,
    isProvidingClient: true,
  },
  {
    path: '/client/:clientId',
    component: ClientHome,
    isProvidingClient: true,
  },
].map(route => ({
  ...route,
  isExact: true,
  isPrivate: true,
  is2FaProtected: true,
}));

export default routes;
